const TEXT_COLOR_INPUT_SELECTOR = [
  'div.is-text-color',
  'input[name*="Choose Text Color"]',
  'input[name*="Choose Name Text Color"]',
  'input[name*="Choose Grade Text Color"]'
].join(', ');
const TEXT_COLOR_SWATCH_SIZE = '40px';
const CUSTOM_YES_NO_OPTION_SELECTOR = '.customily_option.is-custom';
const CUSTOM_YES_NO_OPTION_SIZE = '50px';
const CUSTOMILY_BUTTONS_SELECTOR = '.customily-buttons_container, .csh-buttons_container';
const CUSTOMILY_BUTTONS_FORM_CLASS = 'product-form__buttons--customily';
let isApplyingTextColorStyles = false;
let textColorResizeQueued = false;

function getTextColorLabel(input) {
  if (input.nextElementSibling && input.nextElementSibling.tagName === 'LABEL') {
    return input.nextElementSibling;
  }

  if (input.id && window.CSS && CSS.escape) {
    return document.querySelector(`label[for="${CSS.escape(input.id)}"]`);
  }

  return null;
}

function roundTextColorLabel(label) {
  setImportantStyle(label, 'width', TEXT_COLOR_SWATCH_SIZE);
  setImportantStyle(label, 'height', TEXT_COLOR_SWATCH_SIZE);
  setImportantStyle(label, 'min-width', TEXT_COLOR_SWATCH_SIZE);
  setImportantStyle(label, 'min-height', TEXT_COLOR_SWATCH_SIZE);
  setImportantStyle(label, 'max-width', TEXT_COLOR_SWATCH_SIZE);
  setImportantStyle(label, 'max-height', TEXT_COLOR_SWATCH_SIZE);
  setImportantStyle(label, 'border-radius', '50%');
  setImportantStyle(label, 'overflow', 'hidden');

  label.querySelectorAll('*').forEach(child => {
    setImportantStyle(child, 'border-radius', '50%');
  });
}

function squareCustomYesNoLabel(label) {
  setImportantStyle(label, 'width', CUSTOM_YES_NO_OPTION_SIZE);
  setImportantStyle(label, 'height', CUSTOM_YES_NO_OPTION_SIZE);
  setImportantStyle(label, 'min-width', CUSTOM_YES_NO_OPTION_SIZE);
  setImportantStyle(label, 'min-height', CUSTOM_YES_NO_OPTION_SIZE);
  setImportantStyle(label, 'max-width', CUSTOM_YES_NO_OPTION_SIZE);
  setImportantStyle(label, 'max-height', CUSTOM_YES_NO_OPTION_SIZE);
  setImportantStyle(label, 'aspect-ratio', '1 / 1');
  setImportantStyle(label, 'display', 'inline-flex');
  setImportantStyle(label, 'align-items', 'center');
  setImportantStyle(label, 'justify-content', 'center');
  setImportantStyle(label, 'box-sizing', 'border-box');
  setImportantStyle(label, 'padding', '0');
  setImportantStyle(label, 'line-height', '1.2');
  setImportantStyle(label, 'text-align', 'center');
}

function setImportantStyle(element, property, value) {
  if (
    element.style.getPropertyValue(property) === value &&
    element.style.getPropertyPriority(property) === 'important'
  ) {
    return;
  }

  element.style.setProperty(property, value, 'important');
}

function resizeCustomYesNoOptions() {
  document.querySelectorAll(CUSTOM_YES_NO_OPTION_SELECTOR).forEach(option => {
    const labels = new Set();

    option.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
      const label = getTextColorLabel(input);

      if (label && option.contains(label)) {
        labels.add(label);
      }
    });

    option.querySelectorAll('label:not([aria-controls])').forEach(label => {
      labels.add(label);
    });

    labels.forEach(squareCustomYesNoLabel);
  });
}

function fitCustomilyButtons() {
  document.querySelectorAll('.product-form__purchase-row').forEach(purchaseRow => {
    purchaseRow.classList.toggle(
      'product-form__purchase-row--customily',
      Boolean(purchaseRow.querySelector(CUSTOMILY_BUTTONS_SELECTOR))
    );
  });

  document.querySelectorAll(CUSTOMILY_BUTTONS_SELECTOR).forEach(container => {
    const productFormButtons = container.closest('.product-form__buttons');

    if (productFormButtons) {
      productFormButtons.classList.add(CUSTOMILY_BUTTONS_FORM_CLASS);
    }
  });
}

function resizeTextColorSwatches() {
  isApplyingTextColorStyles = true;

  try {
    document.querySelectorAll(TEXT_COLOR_INPUT_SELECTOR).forEach(el => {
      if (el.tagName === 'DIV') {
        el.querySelectorAll('input[type="radio"], input[type="checkbox"]').forEach(input => {
          const label = getTextColorLabel(input);

          if (label) {
            roundTextColorLabel(label);
          }
        });
      } else {
        const label = getTextColorLabel(el);

        if (label) {
          roundTextColorLabel(label);
        }
      }
    });

    resizeCustomYesNoOptions();
    fitCustomilyButtons();
  } finally {
    isApplyingTextColorStyles = false;
  }
}

function scheduleTextColorSwatchResize() {
  if (textColorResizeQueued) return;

  textColorResizeQueued = true;

  requestAnimationFrame(() => {
    textColorResizeQueued = false;
    resizeTextColorSwatches();
    setTimeout(resizeTextColorSwatches, 50);
    setTimeout(resizeTextColorSwatches, 200);
  });
}

const observer = new MutationObserver(mutations => {
  if (isApplyingTextColorStyles) return;

  const shouldResize = mutations.some(mutation => {
    if (mutation.type === 'childList') return true;
    if (mutation.target.matches && mutation.target.matches(TEXT_COLOR_INPUT_SELECTOR)) return true;
    if (mutation.target.closest && mutation.target.closest('.customily-swatch')) return true;
    if (mutation.target.closest && mutation.target.closest(CUSTOM_YES_NO_OPTION_SELECTOR)) return true;
    if (mutation.target.closest && mutation.target.closest(CUSTOMILY_BUTTONS_SELECTOR)) return true;

    return false;
  });

  if (shouldResize) {
    scheduleTextColorSwatchResize();
  }
});

observer.observe(document.body, {
  attributes: true,
  attributeFilter: ['class', 'style', 'checked'],
  childList: true,
  subtree: true
});

document.addEventListener('click', event => {
  if (
    event.target.closest &&
    (event.target.closest(TEXT_COLOR_INPUT_SELECTOR) || event.target.closest(CUSTOM_YES_NO_OPTION_SELECTOR))
  ) {
    scheduleTextColorSwatchResize();
  }
});

document.addEventListener('change', event => {
  if (
    (event.target.matches && event.target.matches(TEXT_COLOR_INPUT_SELECTOR)) ||
    (event.target.closest && event.target.closest(CUSTOM_YES_NO_OPTION_SELECTOR))
  ) {
    scheduleTextColorSwatchResize();
  }
});

resizeTextColorSwatches();
